export enum Role { 
    Admin = 0,
    User = 1,
    DxPro = 2,
    VennHealth = 3,
    PRECISE = 4,
    PREDICT = 5,
    US_COUNTY_FIPS = 6
}